<template>
  <b-container fluid>
    <admin-preloader :show="loading"/>
    <admin-breadcrumb :items="[{ text: 'Taxonomies', path: {name: 'admin-taxonomies'} }]" name="Strains" no-title/>
    <b-row>
      <b-col cols="12">
        <admin-panel title="Strains">
          <template v-slot:header-right>
            <no-permission-wrapper :show="!canCreateTaxonomies">
              <b-btn variant="success" @click="openNewModal" :disabled="!canCreateTaxonomies">Add new Strain</b-btn>
            </no-permission-wrapper>
          </template>
          <b-table
              :fields="table_fields"
              :items="strains"
              table-class="text-nowrap"
              responsive
          >
            <template #cell(name)="data">
              <h4 class="mb-0">{{ data.item.name }}</h4>
            </template>
            <template #cell(actions)="data">
              <no-permission-wrapper :show="!canUpdateTaxonomies">
                <b-btn variant="primary" @click.prevent="openEditModal(data.item)" :disabled="!canUpdateTaxonomies">Edit</b-btn>
              </no-permission-wrapper>
              <no-permission-wrapper :show="!canDeleteTaxonomies">
                <b-btn variant="danger" @click.prevent="confirmDelete(data.item)" :disabled="!canDeleteTaxonomies">Delete</b-btn>
              </no-permission-wrapper>
            </template>
          </b-table>
        </admin-panel>
      </b-col>
    </b-row>
    <admin-strain-edit-modal
        v-if="edit_strain"
        :strain="edit_strain"
        @cancel="edit_strain = null"
        @success="onStrainEdited"
        visible
    />
    <admin-strain-add-modal
        ref="newModal"
        @success="onStrainAdded"
    />
  </b-container>
</template>

<script>
import AdminPanel from "../components/AdminPanel";
import {API_ROUTES} from "../api";
import AdminPreloader from "../components/AdminPreloader";
import AdminBreadcrumb from "../components/AdminBreadcrumb";
import AdminStrainEditModal from "../components/AdminStrainEditModal";
import AdminStrainAddModal from "../components/AdminStrainAddModal";
import NoPermissionWrapper from "../components/NoPermissionWrapper.vue";

export default {
  name: "AdminStrains",
  components: {
    NoPermissionWrapper,
    AdminStrainAddModal, AdminStrainEditModal, AdminBreadcrumb, AdminPreloader, AdminPanel},
  data() {
    return {
      loading: false,
      table_fields: [
        {
          key: "name",
          thClass: "border-top-0",
          tdClass: "align-middle"
        },
        {
          key: "actions",
          thClass: "border-top-0",
          tdClass: "align-middle"
        }
      ],
      edit_strain: null
    }
  },
  computed: {
    canCreateTaxonomies() {
      return this.$store.getters['auth/hasAdminPermissions']('taxonomy_create');
    },
    canUpdateTaxonomies() {
      return this.$store.getters['auth/hasAdminPermissions']('taxonomy_update');
    },
    canDeleteTaxonomies() {
      return this.$store.getters['auth/hasAdminPermissions']('taxonomy_delete');
    },
    strains() {
      let strains = this.$store.state.data.strains;
      if (this.search) {
        let search = this.search.toLowerCase();
        strains = strains.filter(s => s.name.toLowerCase().indexOf(search) >= 0);
      }

      return strains.sort((item1, item2) => {
        let name1 = item1.name.toLowerCase(),
            name2 = item2.name.toLowerCase();
        if (name1 < name2) {
          return -1;
        }
        if (name1 > name2) {
          return 1;
        }
        return 0;
      });
    }
  },
  methods: {
    checkPermission(permission) {
      if (!this[permission]) {
        this.$bvToast.toast('Sorry! You don\'t have permission to do this action', {
          title: 'Denied!',
          variant: 'danger'
        });
        return false;
      }
      return true;
    },
    openNewModal() {
      if (!this.checkPermission('canCreateTaxonomies')) {
        return;
      }
      this.$refs.newModal.open();
    },
    openEditModal(strain) {
      if (!this.checkPermission('canUpdateTaxonomies')) {
        return;
      }
      this.edit_strain = strain;
    },
    confirmDelete(strain) {
      if (!this.checkPermission('canDeleteTaxonomies')) {
        return;
      }
      this.$bvModal.msgBoxConfirm(`You are going to delete ${strain.name} strain`, {
        title: 'Please confirm',
        okVariant: 'success',
        centered: true
      }).then(value => {
        if (value) {
          this.loading = true;
          this.$api.post(`${API_ROUTES.ADMIN_TAXONOMY_STRAINS}/${strain.id}/delete`).then(() => {
            let index = this.strains.findIndex(s => s.id === strain.id);
            if (index >= 0) {
              let strains = [...this.strains];
              strains.splice(index, 1);
              this.$store.commit('data/setStrains', strains);
            }
            this.$bvToast.toast('Strain type has been successfully deleted', {
              title: 'Success!',
              variant: 'success'
            });
            this.formValidation = {};
          }).catch(({response: {data}}) => {
            this.$bvToast.toast(data.message ?? 'Failed to process operation', {
              title: 'Error!',
              variant: 'danger'
            });
          }).finally(() => {
            this.loading = false;
          });
        }
      });
    },
    onStrainAdded(strain) {
      this.$bvToast.toast('Strain type has been successfully created', {
        title: 'Success!',
        variant: 'success'
      });
      let strains = [...this.strains];
      strains.push(strain);
      this.$store.commit('data/setStrains', strains);
    },
    onStrainEdited(strain) {
      this.$bvToast.toast('Strain type has been successfully updated', {
        title: 'Success!',
        variant: 'success'
      });
      let strains = [...this.strains];
      let index = strains.findIndex(ct => ct.id === strain.id);
      if (index >= 0) {
        strains[index] = strain;
      } else {
        strains.push(strain);
      }
      this.$store.commit('data/setStrains', strains);
    }
  }
}
</script>
